import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M23.25.749,8.158,22.308a2.2,2.2,0,0,1-3.569.059L.75,17.249",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})
});
export default SvgCheckmark;
